import auth from '@/api/auth'
import session from '@/api/session'
import _ from 'lodash'
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
  USER_SUCCESS,
  CLIENT_SUCCESS,
  GET_USERS,
  SET_USERS,
  SET_DEACTIVATED_USERS,
  SET_SLACK,
  GET_SLACK,
  POST_SLACK,
  SAVE_SLACK,
  DELETE_SLACK_LINK,
  SET_CW,
  GET_CW,
  PUT_CW,
  POST_CW,
  SAVE_CW,
  DELETE_CW_LINK,
  GET_WT,
  PUT_WT,
  POST_WT,
  POST_WT_LINK,
  DELETE_WT_LINK,
  NOW_LOADING,
  ADD_MEMBER,
  READD_MEMBER,
  PROFILE_SET,
  PROFILE_SET_U,
  SET_USER_CONNECT,
  SET_COLOR,
  SET_POWER,
  ADD_CARD,
  SET_CARD,
  SET_CARDS_ORDER,
  EDIT_CARD,
  DELETE_CARD,
  ADD_FAVORITE,
  SET_FAVORITE,
  DELETE_FAVORITE,
  SET_RH_MODAL,
  SEND_RH,
  SET_PR_MODAL,
  SEND_PR,
  CHK_TKN,
  RE_ISSUE,
  RE_CREATE_PASS,
  GET_COMPANY_LIST,
  SET_USER_COMPANY,
  GOOGLE_AUTH_REVOKE,
  SET_ICON_IMG,
  GET_QUERY,
  GET_QUERY_DELET,
  GET_SEARCH,
  SEND_SBSCB,
  DEMO_IMAGE,
  SEND_CV,
  SEND_CV_NO,
  SET_TOP,
  PROFILE_IMAGE,
  GET_CATEGORY,
  PUT_CATEGORY,
  POST_CATEGORY,
  DELETE_CATEGORY,
  OMIT_RECENT_APPLICANT_DUPFLG,
  SET_RECENT_APPLICANT_DUPFLG,
} from '../types'

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY'
const IS_CLIENT = 'IS_CLIENT'
const IS_USER = 'IS_USER'

const initialState = {
  pwChanged: '',
  isUser: false,
  isClient: false,
  isMessageView: false,
  messageViewSeeker: {},
  messageCompany: {},
  authenticating: false,
  isLoading: false,
  isModalPasswordReset: false,
  isModalLoginReset: false,
  isModalRequestHelp: false,
  isModalRequestHelpSearch: false,
  isResetTokenExpired: false,
  finishReIssue: false,
  isResetTokenLoading: true,
  isUpdating: false,
  success: false,
  error: false,
  token: null,
  isGoogleAuth: false,
  isGoogleDriveAuth: false,
  user: {},
  users: [],
  deactivated_users: [],
  profileInfo: {},
  companyList: [],
  snippets: '',
  query_url_direct: null,
  query_url_chat: null,
  slack: {
    team: null,
    channel: null,
    on: false,
    sec: 0,
    isSlackLink: false
  },
  slackPersonal: {
    team: null,
    channel: null,
    on: false,
    sec: 0,
    isSlackLink: false
  },
  cw: {
    roomName: null,
    on: false,
    sec: 0,
    isCWLink: false
  },
  searchResult: {
    record: null,
    filed: null,
    serachword: null,
    noResult: false
  },  
  wt: {
    api_key: '',
    department_name: '',
    subscribe_room_name: '',
    subscribe_room_id: '',
    company: '',
    account_id: '',
    password: '',
    is_subscribe: false,
  },
  isWowTalk: false,
  isSlackandCW: false,
  cwRooms: [],
  botstatus: [],
  color: {
    iconBg: '#218BE9',
    iconFr: '#FFFFFF',
    iconBallon: '#218BE9',
    iconMsg: '#FFFFFF',
    header: '#218BE9',
    balloonMy: '#218BE9',
    balloonOtr: 'rgb(218, 253, 243)',
    sendBtn: '#218BE9',
    template: 0,
    customMsg: '',
    iconHeight: '',
    iconWidth: '',
    iconRadius: ''
  },
  power: false,
  cards: [
    {
      type: 'ynbutton',
      text: '',
      editable: false
    },
    {
      type: 'textarea',
      text: '転職をご希望ですか？',
      editable: false
    },
    {
      type: 'textarea',
      text: 'ご訪問ありがとうございます！募集職種等、社内の雰囲気、面談などについて、お知りになりたいことがありましたら、ぜひお声がけ下さい。',
      editable: false
    }
  ],
  demoImage: null,
  isGetImage: false,
  isDemoLoading: false,
  isSendCVLoading: false,
  isSendCVSended: false,
  isEmailSent: false,
  isInitCreatingRecruitmentFlow: false,
  videoInterviewInfo: null,
  isErrorVideoInterviewInfo: false,
  storeCategory: [],
  emailTemplates: [],
  SMSTemplates: [],
  companyRecruit: [],
  displaycompanyRecruit: [],
  companyColumnSetting: [],
  companyPulldownColumns: [], //会社の選択肢入力の際のプルダウンメニュー
  pulldownOptions: {},
  scouts: [],
  recruitmentFlows: [],
  manages: [],
  select_manages: [],
  default_manage: [],
  recruitmentFlowStages: [],
  recruitmentFlowStatus: [],
  recruitmentFlowActions: [],
  errorMessage: "",
  followDatas: [],
  followState: false,
  departments: [],
  positions: [],
  calendarBookMarks: [],
  calendarSettings: [],
  calendarSettingsDisplay: [],
  calendarEventHistory: [],
  userChatBotBookMark: [],
  scoutFiltering: [],
  scoutAutoSending: [],
  payperuseInfoData: null,
  companyHomePages: [],
  controlLogs: [],
  controlLogFilterItems: [],
  controlLogLoading: false,
  controlLogComplete: false,
  controlLogViewID: null,
  usersStatusAPI: [],
  mediaCooperationList: [],
  recentApplicantDupflg: false,
  getUserWaiting: false,
  system_tab_names: ['応募者一覧', '採用フロー停止', 'アーカイブ'], // デフォルト値
}

const getters = {
  isAuthenticated: state => !!state.token,
  isClient: state => !!state.isClient,
  isUser: state => !!state.isUser,
  isAgent: state => state.user.isAgent || false,
  error: state => state.error,
  getUser: state => state.user,
  // 特定の列のプルダウンオプションを取得するgetter
  getPulldownOptionsForColumn: (state) => (columnId) => {
    return state.pulldownOptions[columnId] || [];
  },
  hasLineChannel: state => state.user.has_line_channel || false,
}

const actions = {
  login ({commit}, {email, password}) {
    // django.contribによる認証で弾いても、
    // obtain_jwt_tokenによる認証で通ってログインできてしまうので、
    // リクエストを分割
    commit(LOGIN_BEGIN)
    // django.contribによる認証
    return auth.login(email, password)
      .then(() => {
        // obtain_jwt_tokenによる認証
        return auth.tokenLogin(email, password)
        .then((data) => {
          commit(LOGIN_SUCCESS)
          const token = data.data.token
          const is_user = data.data.is_user
          const is_client = data.data.is_client
          commit(SET_TOKEN, {token, is_client, is_user})
        })
        .catch((error) => {
          console.error('error: ' + error)
          commit(LOGIN_FAILURE)
        })
      })
      .catch((error) => {
        console.error('error: ' + error)
        commit(LOGIN_FAILURE,error)
      })
    },
  logout ({commit}) {
    commit(LOGOUT, 1)
    return auth.logout()
      .then(()=>{
        commit(LOGOUT, 2)
      })
  },
  forceLogout ({commit}) {
    // 自動ログインに関するトークンだけを削除する
    commit(REMOVE_TOKEN)
  },
  // message_page用ログイン認証
  messageLogin ({commit}, { tel, seeker_id }) {
    return auth.messageLogin(tel,seeker_id)
      .then((data) => {
        commit("setMessageViewSeeker",data)
        commit("setIsMessage")
      })
      .catch((error) => {
        alert("電話番号が異なります")
        console.error('error: ' + error)
      })
  },
  // message_page用初期化
  initializeMessageLogin({commit}){
    commit("resetIsMessage")
  },
  // MessagePageの会社情報取得
  getMessageCompany ({commit}, {company_id}) {
    return auth.getMessageCompany(company_id)
      .then((d) => {
        commit("setMessageCompany",d)
      })
      .catch((e) => {
        alert("エラーが発生しました")
        console.error('error: ' + e)
      })
  },
  // MessagePageでのseeker情報の再取得処理
  repossessionSeeker({commit},{seeker_id}){
    return auth.repossessionSeeker(seeker_id)
    .then((data) => {
      commit("setMessageViewSeeker",data)
    })
    .catch((e) => {
      alert("エラーが発生しました")
      console.error('error: ' + e)
    })
  },
  initialize ({commit}) {
    const token     = localStorage.getItem(TOKEN_STORAGE_KEY)
    const is_user   = localStorage.getItem(IS_USER)   === 'true' ? true : false
    const is_client = localStorage.getItem(IS_CLIENT) === 'true' ? true : false
    if (token) {
      commit(SET_TOKEN, {token, is_client, is_user})
    } else {
      commit(REMOVE_TOKEN)
    }
  },
  companyPageSave ({commit}, data) {
      commit(PROFILE_IMAGE, data)
  },
  compnayPageCapture ({commit}) {
    auth.compnayPageCapture()
      .then((d) => {console.log('data_compnayPageCapture: ' + JSON.stringify(d))})
      .catch((e) => {console.log('err_compnayPageCapture: ' + JSON.stringify(e))})
  },
  async getAccountDetails ({commit}) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    const is_user = localStorage.getItem(IS_USER)  === 'true' ? true : false
    const is_client = localStorage.getItem(IS_CLIENT) === 'true' ? true : false
    if (token) {
      await commit(SET_TOKEN, {token, is_client, is_user})
    } else {
      await commit(REMOVE_TOKEN)
    }
    await auth.getAccountDetails()
      .then(async (data) => {
        console.log('data: ' + JSON.stringify(data))
        await commit(CLIENT_SUCCESS, data)
      })
      .catch(async (error) => {
        console.log(error)
      })
  },
  getAccountDetailsUser ({commit}) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    const is_user = localStorage.getItem(IS_USER)  === 'true' ? true : false
    const is_client = localStorage.getItem(IS_CLIENT) === 'true' ? true : false
    if (token) {
      commit(SET_TOKEN, {token, is_client, is_user})
    } else {
      commit(REMOVE_TOKEN)
    }
    if (token) {
      auth.getAccountDetailsUser()
        .then((data) => {
          commit(USER_SUCCESS, data)
        })
        .catch((e) => {
          console.error(e)
        })
    }
    },
  setProfile ({commit, dispatch}, {data, type}) {
    commit('setUpdatingStatus', 0)
    auth.setProfile(data, type)
      .then((d) => {
        commit('setUser', d.data)
        dispatch('getUsers')
        commit('setUpdatingStatus', 1)
      })
      .catch((e) => {
        commit('setUpdatingStatus', 2)
      })
  },
  setProfileUser ({commit}, {data, type}) {
    return auth.setProfileUser(data, type)
    .then((d) => {
      commit(PROFILE_SET_U, type)
    })
    .catch((e) => {
      console.error('e: ' + JSON.stringify(e))
      commit('PROFILE_SET_U_ERROR', type)
    })
  },
  setUserIcon ({commit}, {name, data}) {
    return auth.setUserIcon(name, data.replace(/^.*,/, ''))
      .then((d) => {
        commit('SET_USER_ICON', d.data)
      })
      .catch((e) => {
        console.log(e)
      })
  },
  getUsers ({commit}) {
    commit(GET_USERS)
  },
  async setUsers ({commit}, data) {
    await auth.setUsers(data)
      .then((d) => {
        commit(SET_USERS, d.data)
      })
  },
  setUserConnect ({commit}, data) {
    commit(SET_USER_CONNECT, data)
  },
  getDeactivatedUsers({commit}) {
    auth.getDeactivatedUsers()
      .then((d) => {
        commit(SET_DEACTIVATED_USERS, d.data)
      })
  },
  slackLink ({commit}, {code, sec, on}) {
    commit(NOW_LOADING)
    commit(SET_SLACK, {code, sec, on})
  },
  updateSlack ({commit}, slack) {
    commit(SAVE_SLACK, slack)
  },
  getSlackStatus ({commit}) {
    commit(GET_SLACK)
  },
  slackPost ({commit}, {companyID, seekerID, msg}) {
    commit(POST_SLACK, {companyID, seekerID, msg})
  },
  deleteSlackLink ({commit}) {
    commit(DELETE_SLACK_LINK)
  },
  CWLink ({commit}, {code, sec, on}) {
    commit(NOW_LOADING)
    commit(SET_CW, {code, sec, on})
  },
  getCWStatus ({commit}) {
    commit(GET_CW)
  },
  CWPut ({commit}, {rid, rname}) {
    commit(PUT_CW, {rid, rname})
  },
  CWPost ({commit}, {companyID, seekerID, msg}) {
    commit(POST_CW, {companyID, seekerID, msg})
  },
  updateCW ({commit}, cw) {
    commit(SAVE_CW, cw)
  },
  deleteCWLink ({commit}) {
    commit(DELETE_CW_LINK)
  },
  getWTStatus ({commit}) {
    commit(GET_WT)
  },
  WTPut ({commit}, wt) {
    commit(PUT_WT, wt)
  },
  WTPost ({commit}, {companyID, seekerID, msg}) {
    commit(POST_WT, {companyID, seekerID, msg})
  },
  postWTLink ({commit}, wt) {
    commit(POST_WT_LINK, wt)
  },
  deleteWTLink ({commit}) {
    commit(DELETE_WT_LINK)
  },
  addMember ({commit}, data) {
    commit(ADD_MEMBER, data)
  },
  reAddMember ({commit}, data) {
    commit(READD_MEMBER, data)
  },
  setColor ({commit}, color) {
    commit(SET_COLOR, color)
  },
  setPower ({commit}, power) {
    commit(SET_POWER, power)
  },
  addCard ({commit}, {type, text}) {
    commit(ADD_CARD, {type, text})
  },
  setCard ({commit}, {id, type, text, index}) {
    commit(SET_CARD, {id, type, text, index})
  },
  setCardsOrder ({commit}, cards) {
    commit(SET_CARDS_ORDER, cards)
  },
  editCard ({commit}, data) {
    commit(EDIT_CARD, data)
  },
  deleteCard ({commit}, {id, type, text, isDelete, index}) {
    commit(DELETE_CARD, {id, type, text, isDelete, index})
  },
  addFavorite ({commit}, {type, typename, name}) {
    commit(ADD_FAVORITE, {type, typename, name})
  },
  setFavorite ({commit}, {id, type, typename, name, index, num}) {
    commit(SET_FAVORITE, {id, type, typename, name, index, num})
  },
  deleteFavorite ({commit}, {id, type, typename, name, index}) {
    commit(DELETE_FAVORITE, {id, type, typename, name, index})
  },
  setRHModal ({commit}) {
    commit(SET_RH_MODAL)
  },
  sendRH ({commit}, data) {
    commit(SEND_RH, data)
  },
  setPRModal ({commit}) {
    commit(SET_PR_MODAL)
  },
  sendPR ({commit}, data) {
    commit(SEND_PR, data)
  },
  sendLoginReset ({commit}, data) {
    commit(SEND_LOGIN_RESET, data)
  },
  checkToken ({commit}, id) {
    commit(CHK_TKN, id)
  },
  reIssue ({commit}, id) {
    commit(RE_ISSUE, id)
  },
  reCreatePassword ({commit}, {password, id}) {
    commit(RE_CREATE_PASS, {password, id})
  },
  getCompanyList ({commit}) {
    commit(GET_COMPANY_LIST)
  },
  updateUserCompany ({commit}, companyID) {
    commit(SET_USER_COMPANY, companyID)
  },
  googleAuthRevoke ({commit}) {
    commit(GOOGLE_AUTH_REVOKE)
  },
  googleDriveAuth ({commit, state}, {email, username}) {
    var uri = process.env.OWN_ENDPOINT
    // localhost の時は切り替える
    if (uri === 'http://localhost:8080') uri = 'http://localhost:8000'
    const params = '/api/user/google_drive_auth?email=' + email + '&username=' + username
    location.href = uri + params
  },
  googleDriveAuthRevoke ({commit, state}) {
    auth.googleDriveAuthRevoke(state.user.email)
      .then(() => {
        commit('GET_GOOGLE_DRIVE_AUTH_STATUS', 'NotAuthorized')
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  async getGoogleDriveAuthStatus ({commit}) {
    const result = await auth.getGoogleDriveAuthStatus()
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        return
      })
    commit('GET_GOOGLE_DRIVE_AUTH_STATUS', result.data.status)
  },
  msofficeAuthRevoke ({commit}) {
    auth.msofficeAuthRevoke()
      .then((d) => {
        commit('MSOFFICE_AUTH_REVOKE')
      })
      .catch((e) => {
        alert('エラーが発生しました。')
      })
  },
  getLineChannelInfo ({commit}) {
    return auth.getLineChannelInfo()
  },
  setLineChannelInfo ({commit}, {channel_id, channel_secret}) {
    return auth.setLineChannelInfo({channel_id, channel_secret})
      .then((d) => {
        commit('SET_LINE_CHANNEL_INFO', true)
        return d
      })
      .catch((e) => {
        throw e
      })
  },
  deleteLineChannelInfo ({commit}) {
    return auth.deleteLineChannelInfo()
      .then((d) => {
        commit('SET_LINE_CHANNEL_INFO', false)
        return d
      })
      .catch((e) => {
        throw e
      })
  },
  setIconImage ({commit}, {name, data}) {
    commit(SET_ICON_IMG, {name, data})
  },
  getQuery ({commit}, name) {
    commit(GET_QUERY, name)
  },
  getQueryDelet({commit},data) {
    commit(GET_QUERY_DELET,data)
  },  
  getSearch ({commit}, searchWord) {
    commit(GET_SEARCH, searchWord)
  },
  async sendSubscribe ({commit}, data) {
    return await commit(SEND_SBSCB, data)
  },
  demoImage ({commit}, data) {
    commit(DEMO_IMAGE, data)
  },
  sendMessage ({commit}, data) {
    commit(SEND_CV, data)
  },
  async sendSubscribeNoData ({commit}, data) {
    // WebsocketでのRoom参照処理とかぶってデッドロックするので同期処理にする
    // 本処理が終わってから後続のWebsocketのsend処理を行う
    return await commit(SEND_CV_NO, data)
  },
  createTopLPUser ({commit}, data) {
    commit(SET_TOP, data)
  },
  getVideoInterviewInfo ({commit}, id) {
    commit('GET_VIDEO_INFO', id)
  },
  getStoreCateogry ({commit}) {
    auth.getStoreCateogry()
      .then((d) => {
        commit(GET_CATEGORY, d.data)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  putStoreCateogry ({commit}, data) {
    auth.putStoreCateogry(data)
      .then((d) => {
        commit(PUT_CATEGORY, d.data)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  postStoreCateogry ({commit}, data) {
    auth.postStoreCateogry(data)
      .then((d) => {
        commit(POST_CATEGORY, d.data)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  deleteStoreCateogry ({commit}, id) {
    auth.deleteStoreCateogry(id)
      .then((d) => {
        commit(DELETE_CATEGORY, id)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  changeShape({ commit }, payload) {
    commit('CHANGE_SHAPE', payload)
  },
  changeIconHeight ({ commit }, payload) {
    commit('CHANGE_ICON_HEIGHT', payload)
  },
  changeIconWidth ({ commit }, payload) {
    commit('CHANGE_ICON_WIDTH', payload)
  },
  changeIconRadius ({ commit }, payload) {
    commit('CHANGE_ICON_RADIUS', payload)
  },
  // Company Recruit API
  createCompanyRecruit ({commit}, data) {
    auth.createCompanyRecruit(data)
      .then((d) => {
        commit('CREATE_CREC', JSON.parse(d.data))
        commit('CREATE_DCREC', JSON.parse(d.data))
        alert('登録しました。')
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getCompanyRecruit ({commit}, id) {
    auth.getCompanyRecruit(id)
      .then((d) => {
        commit('GET_CREC', JSON.parse(d.data))
        auth.getDisplayCompanyRecruit(JSON.parse(d.data))
          .then((d) => {
            commit('GET_DCREC', JSON.parse(d.data))
          })
          .catch((e) => {
            console.error(e)
            alert('エラーが発生いたしました。')
          })
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getMediaCooperationList ({commit}) {
    auth.getMediaCooperationList()
      .then((d) => {
        commit('GET_MEDIA_COOPE_LIST', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })

  },
  updateCompanyRecruit ({commit}, data) {
    auth.updateCompanyRecruit(data)
      .then((d) => {
        commit('UPDATE_CREC', JSON.parse(d.data))
        alert('更新しました。')
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCompanyRecruit ({commit}, id) {
    auth.deleteCompanyRecruit(id)
      .then((d) => {
        commit('DELETE_CREC', id)
        alert('削除しました。')
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // Email Template API
  createCompanyEmailTemplate ({commit}, data) {
    return auth.createCompanyEmailTemplate(data)
      .then((d) => {
        commit('CREATE_CETEMP', JSON.parse(d.data))
        return JSON.parse(d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getCompanyEmailTemplate ({commit}, id) {
    auth.getCompanyEmailTemplate(id)
      .then((d) => {
        commit('GET_CETEMP', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateCompanyEmailTemplate ({commit}, data) {
    auth.updateCompanyEmailTemplate(data)
      .then((d) => {
        commit('UPDATE_CETEMP', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCompanyEmailTemplate ({commit}, id) {
    auth.deleteCompanyEmailTemplate(id)
      .then((d) => {
        commit('DELETE_CETEMP', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateOrderCompanyEmailTemplate ({commit}, data) {
    auth.updateOrderCompanyEmailTemplate(data)
      .then((d) => {
        commit('UPDATE_ORDERCETEMPAL', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // Email(SMS) Template API
  createCompanySMSTemplate ({commit}, data) {
    auth.createCompanySMSTemplate(data)
      .then((d) => {
        commit('CREATE_CSTEMP', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getCompanySMSTemplate ({commit}, id) {
    auth.getCompanySMSTemplate(id)
      .then((d) => {
        commit('GET_CSTEMP', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateCompanySMSTemplate ({commit}, data) {
    auth.updateCompanySMSTemplate(data)
      .then((d) => {
        commit('UPDATE_CSTEMP', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCompanySMSTemplate ({commit}, id) {
    auth.deleteCompanySMSTemplate(id)
      .then((d) => {
        commit('DELETE_CSTEMP', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // Company Column Setting API
  createCompanyColumnSetting ({commit}, data) {
    auth.createCompanyColumnSetting(data)
      .then((d) => {
        commit('CREATE_CCOL', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getCompanyColumnSetting ({commit}, id) {
    return auth.getCompanyColumnSetting(id)
      .then((d) => {
        commit('GET_CCOL', JSON.parse(d.data))
        return JSON.parse(d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateCompanyColumnSetting ({commit}, data) {
    auth.updateCompanyColumnSetting(data)
      .then((d) => {
        commit('UPDATE_CCOL', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCompanyColumnSetting ({commit}, id) {
    auth.deleteCompanyColumnSetting(id)
      .then((d) => {
        commit('DELETE_CCOL', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // Company Pulldown Column API
  // 新しいプルダウンカラムを作成
  async  createCompanyPulldownColumn({ commit }, newOptionData) {
    try {
      const response = await auth.createCompanyPulldownColumn(newOptionData);
      console.log('Resopnse data:', response.data);
      commit('ADD_PULLDOWN_COLUMN', response.data); // .newOptionData を削除
      return response.data; // 戻り値を追加
    } catch (error){
      alert("エラーが発生しました。")
      console.error('createCompanyPulldownColumnでエラーが発生しました。')
    }
  },
  // プルダウンカラムを取得
  async fetchCompanyPulldownColumns({ commit }, payload) {
    try {
      let response;
      let columnId;

      // payloadがオブジェクトの場合（新しい要件）
      if (typeof payload === 'object' && payload !== null) {
        columnId = payload.columnId;
        response = await auth.fetchCompanyPulldownColumns(columnId);
        if (response && response.data) {
          const tempPulldownColumnOptions = response.data
            .map(item => ({
              id: item.id,
              name: item.name,
              order: item.order
            }))
            .sort((a, b) => a.order - b.order); // ここでソート
          commit('SET_PULLDOWN_OPTIONS', { columnId, tempPulldownColumnOptions });
          console.log('Fetched pulldown tempPulldownColumnOptions:', tempPulldownColumnOptions);
        } else {
          console.error('選択肢の取得に失敗しました');
          throw new Error('選択肢の取得に失敗しました');
        }
      }
      // payloadが直接columnIdの場合（既存の動作）
      else {
        columnId = payload;
        response = await auth.fetchCompanyPulldownColumns(columnId);
        const sortedData = response.data.sort((a, b) => a.order - b.order); // ここでもソート
        commit('SET_PULLDOWN_OPTIONS', response.data);
      }

      return response.data;
    } catch (error) {
      console.error('選択肢の取得に失敗しました:', error);
      throw error;
    }
  },
  // プルダウンカラムを更新
  updateCompanyPulldownColumn({ commit }, data) {
    return auth.updateCompanyPulldownColumn(data)
      .then((response) => {
        commit('UPDATE_PULLDOWN_COLUMN', response.data);
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        alert('エラーが発生しました。');
      });
  },
  // プルダウンカラムを削除
  deleteCompanyPulldownColumn({ commit }, id) {
    return auth.deleteCompanyPulldownColumn(id)
      .then(() => {
        commit('DELETE_PULLDOWN_COLUMN', id);
      })
      .catch((error) => {
        console.error(error);
        alert('エラーが発生しました。');
      });
  },
  // プルダウンオプションを更新
  async updateCompanyPulldownOptions({ commit }, { columnId, options }) {
    try {
      // API呼び出しをここに追加（必要に応じて）
      // const response = await auth.updateCompanyPulldownOptions(columnId, options);

      commit('UPDATE_PULLDOWN_OPTIONS', { columnId, options });
      return options;
    } catch (error) {
      console.error('選択肢の更新に失敗しました:', error);
      throw error;
    }
  }, 
  // Scout API
  createScout ({commit}, data) {
    return auth.createScout(data)
      .then((d) => {
        commit('CREATE_SCT', JSON.parse(d.data))
        return JSON.parse(d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        return
      })
  },
  getScout ({commit}, id) {
    auth.getScout(id)
      .then((d) => {
        commit('GET_SCT', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateScout ({commit}, data) {
    auth.updateScout(data)
      .then((d) => {
        commit('UPDATE_SCT', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteScout ({commit}, id) {
    auth.deleteScout(id)
      .then((d) => {
        commit('DELETE_SCT', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // intit create recruit flow
  initialCreateRecruitmentFlow ({commit}) {
    commit('INIT_RF_START')
    auth.initialCreateRecruitmentFlow()
      .then((d) => {
        commit('GET_RF', JSON.parse(d.data))
        commit('INIT_RF_END')
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        commit('INIT_RF_END')
      })
  },
  // RecruitmentFlow API
  createRecruitmentFlow ({commit}, data) {
    auth.createRecruitmentFlow(data)
      .then((d) => {
        commit('CREATE_RF', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getRecruitmentFlow ({commit}, id) {
    auth.getRecruitmentFlow(id)
      .then((d) => {
        commit('GET_RF', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateRecruitmentFlow ({commit}, data) {
    auth.updateRecruitmentFlow(data)
      .then((d) => {
        commit('UPDATE_RF', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteRecruitmentFlow ({commit}, id) {
    auth.deleteRecruitmentFlow(id)
      .then((d) => {
        commit('DELETE_RF', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // RecruitmentFlowStage API
  createRecruitmentFlowStage ({commit}, data) {
    auth.createRecruitmentFlowStage(data)
      .then((d) => {
        commit('CREATE_RFSTG', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getRecruitmentFlowStage ({commit}, id) {
    auth.getRecruitmentFlowStage(id)
      .then((d) => {
        commit('GET_RFSTG', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateRecruitmentFlowStage ({commit}, data) {
    auth.updateRecruitmentFlowStage(data)
      .then((d) => {
        commit('UPDATE_RFSTG', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteRecruitmentFlowStage ({commit}, id) {
    auth.deleteRecruitmentFlowStage(id)
      .then((d) => {
        commit('DELETE_RFSTG', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // CreateManage API
  createManage ({commit}, data) {
    auth.createManage(data)
    .then((d) => {
      commit('CREATE_MNG', JSON.parse(d.data))
      alert('応募者管理画面を追加いたしました。')
    })
    .catch((e) => {
      console.error(e)
      alert('エラーが発生いたしました。')
    })
  },
  // UpdateManage API
  updateManage ({commit}, data) {
    return auth.updateManage(data)
    .then((d) => {
      commit('UPDATE_MNG', JSON.parse(d.data))
      alert('タブ名を変更いたしました。')
      return Promise.resolve(JSON.parse(d.data))
    })
    .catch((e) => {
      console.error(e)
      const errorMessage = (e.response && e.response.data && e.response.data.error) || 'エラーが発生いたしました。'
      alert(errorMessage)
      return Promise.reject(e)
    })
  },
  // DeleteManage API
  deleteManage ({commit}, id) {
    return auth.deleteManage(id)
    .then((d) => {
      commit('DELETE_MNG', id)
      // d.dataがすでにオブジェクトの場合とJSON文字列の場合の両方に対応
      let result
      try {
        result = typeof d.data === 'string' ? JSON.parse(d.data) : d.data
      } catch (error) {
        console.error('Failed to parse response:', d.data)
        result = d.data
      }
      alert(`タブ「${result.deleted_tab_name}」を削除いたしました。`)
      return Promise.resolve(result)
    })
    .catch((e) => {
      console.error(e)
      const errorMessage = (e.response && e.response.data && e.response.data.error) || 'エラーが発生いたしました。'
      alert(errorMessage)
      return Promise.reject(e)
    })
  },
  getManageDeletionImpact ({commit}, id) {
    return auth.getManageDeletionImpact(id)
    .then((d) => {
      let data
      try {
        data = typeof d.data === 'string' ? JSON.parse(d.data) : d.data
      } catch (error) {
        console.error('Failed to parse response:', d.data)
        data = d.data
      }
      return Promise.resolve(data)
    })
    .catch((e) => {
      console.error(e)
      return Promise.reject(e)
    })
  },
  async getcreateManage ({commit}, id) {
    await auth.getcreateManage(id)
    .then((d) => {
      let data
      try {
        data = typeof d.data === 'string' ? JSON.parse(d.data) : d.data
      } catch (error) {
        console.error('Failed to parse response:', d.data)
        data = d.data
      }
      commit('GET_MNG', data.manages || data)
      commit('GET_SELECT_MNG', data.manages || data)
      commit('GET_DEFAULT_MNG', data.manages || data)
      if (data.system_tab_names) {
        commit('SET_SYSTEM_TAB_NAMES', data.system_tab_names)
      }
    })
    .catch((e) => {
      console.error(e)
      alert('エラーが発生いたしました。')
    })
  },
  // RecruitmentFlowStatus API
  createRecruitmentFlowStatus ({commit}, data) {
    auth.createRecruitmentFlowStatus(data)
      .then((d) => {
        commit('CREATE_RFSTS', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getRecruitmentFlowStatus ({commit}, id) {
    auth.getRecruitmentFlowStatus(id)
      .then((d) => {
        commit('GET_RFSTS', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateRecruitmentFlowStatus ({commit}, data) {
    auth.updateRecruitmentFlowStatus(data)
      .then((d) => {
        commit('UPDATE_RFSTS', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteRecruitmentFlowStatus ({commit}, id) {
    auth.deleteRecruitmentFlowStatus(id)
      .then((d) => {
        commit('DELETE_RFSTS', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // RecruitmentFlowAction API
  createRecruitmentFlowAction ({commit}, data) {
    auth.createRecruitmentFlowAction(data)
      .then((d) => {
        commit('CREATE_RFACT', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getRecruitmentFlowAction ({commit}, id) {
    auth.getRecruitmentFlowAction(id)
      .then((d) => {
        commit('GET_RFACT', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  async updateRecruitmentFlowAction ({commit}, data) {
    const res = await auth.updateRecruitmentFlowAction(data)
    commit('UPDATE_RFACT', JSON.parse(res.data))
  },
  deleteRecruitmentFlowAction ({commit}, id) {
    auth.deleteRecruitmentFlowAction(id)
      .then((d) => {
        commit('DELETE_RFACT', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getFollow({ commit }, id) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    const is_user = localStorage.getItem(IS_USER)  === 'true' ? true : false
    const is_client = localStorage.getItem(IS_CLIENT) === 'true' ? true : false
    if (token) {
      commit(SET_TOKEN, { token, is_client, is_user })
      auth.getFollow(id)
      .then((d) => {
        commit('GET_FOLLOW', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
    } else {
      commit(REMOVE_TOKEN)
    }
  },
  getFollowInfo({commit}) {
    auth.getFollowInfo()
      .then((d) => {
        commit('GET_FOLLOW_INFO', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  addFollow({ commit }, data) {
    auth.addFollow(data)
      .then((d) => {
        commit('ADD_FOLLOW', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteFollow({ commit }, data) {
    auth.deleteFollow(data)
      .then((d) => {
        commit('DELETE_FOLLOW', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // Department API
  createDepartment ({commit}, data) {
    auth.createDepartment(data)
      .then((d) => {
        commit('CREATE_DEPART', d.data)
      })
      .catch((e) => {
        alert('エラーが発生いたしました。')
      })
  },
  bulkCreateDepartment ({commit}, data) {
    return auth.bulkCreateDepartment(data)
      .then((d) => {
        commit('GET_DEPART', JSON.parse(d.data))
        return
      })
      .catch((e) => {
        alert('エラーが発生いたしました。')
        return
      })
  },
  getDepartment ({commit}, id) {
    auth.getDepartment(id)
      .then((d) => {
        console.log('getDepartment', d)
        commit('GET_DEPART', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateDepartment ({commit}, data) {
    auth.updateDepartment(data)
      .then((d) => {
        commit('UPDATE_DEPART', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteDepartment ({commit}, id) {
    auth.deleteDepartment(id)
      .then((d) => {
        commit('DELETE_DEPART', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // Position API
  createPosition ({commit}, data) {
    auth.createPosition(data)
      .then((d) => {
        commit('CREATE_POSITION', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  bulkCreatePosition ({commit}, data) {
    return auth.bulkCreatePosition(data)
      .then((d) => {
        commit('GET_POSITION', JSON.parse(d.data))
        return
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        return
      })
  },
  getPosition ({commit}, id) {
    auth.getPosition(id)
      .then((d) => {
        console.log('getPosition', d)
        commit('GET_POSITION', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updatePosition ({commit}, data) {
    auth.updatePosition(data)
      .then((d) => {
        commit('UPDATE_POSITION', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deletePosition ({commit}, id) {
    auth.deletePosition(id)
      .then((d) => {
        commit('DELETE_POSITION', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // CalendarBookMark API
  createCalendarBookMark ({commit}, data) {
    auth.createCalendarBookMark(data)
      .then((d) => {
        commit('CREATE_CBM', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getCalendarBookMark ({commit}, id) {
    auth.getCalendarBookMark(id)
      .then((d) => {
        console.log('getCalendarBookMark', d)
        commit('GET_CBM', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateCalendarBookMark ({commit}, data) {
    auth.updateCalendarBookMark(data)
      .then((d) => {
        commit('UPDATE_CBM', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCalendarBookMark ({commit}, id) {
    auth.deleteCalendarBookMark(id)
      .then((d) => {
        commit('DELETE_CBM', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // UserCalendarSetting API
  async createUserCalendarSetting ({commit}, data) {
    const res = await auth.createUserCalendarSetting(data)
    commit('CREATE_UCS', res.data)
  },
  getUserCalendarSetting ({commit}, id) {
    auth.getUserCalendarSetting(id)
      .then((d) => {
        commit('GET_UCS', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateUserCalendarSetting ({commit}, data) {
    return auth.updateUserCalendarSetting(data)
      .then((d) => {
        commit('UPDATE_UCS', d.data)
        return
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        return
      })
  },
  deleteUserCalendarSetting ({commit}, id) {
    auth.deleteUserCalendarSetting(id)
      .then((d) => {
        commit('DELETE_UCS', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // UserCalendarSettingDisplay（面接予定設定・変更時に空き時間を確認するためのカレンダー） API
  async createUserCalendarSettingDisplay ({commit}, data) {
    commit('CREATE_UCSD', data)
  },
  deleteUserCalendarSettingDisplay ({commit}, data) {
    commit('DELETE_UCSD', data)
  },
  clearUserCalendarSettingDisplay ({commit}) {
    commit('CLEAR_UCSD')
  },
  // UserCalendarEventHistory API
  createUserCalendarEventHistory ({commit}, data) {
    auth.createUserCalendarEventHistory(data)
      .then((d) => {
        commit('CREATE_UCEH', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getUserCalendarEventHistory ({commit}, id) {
    auth.getUserCalendarEventHistory(id)
      .then((d) => {
        commit('GET_UCEH', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateUserCalendarEventHistory ({commit}, data) {
    auth.updateUserCalendarEventHistory(data)
      .then((d) => {
        commit('UPDATE_UCEH', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteUserCalendarEventHistory ({commit}, id) {
    auth.deleteUserCalendarEventHistory(id)
      .then((d) => {
        commit('DELETE_UCEH', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // UserChatBotBookMark API
  async createUserChatBotBookMark ({commit}, data) {
    return await auth.createUserChatBotBookMark(data)
      .then((d) => {
        commit('CREATE_UCB', d.data)
        return true
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        return false
      })
  },
  getUserChatBotBookMark ({commit}, id) {
    auth.getUserChatBotBookMark(id)
      .then((d) => {
        commit('GET_UCB', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateUserChatBotBookMark ({commit}, data) {
    auth.updateUserChatBotBookMark(data)
      .then((d) => {
        commit('UPDATE_UCB', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  async deleteUserChatBotBookMark ({commit}, id) {
    return await auth.deleteUserChatBotBookMark(id)
      .then((d) => {
        commit('DELETE_UCB', id)
        return true
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        return false
      })
  },
  // ScoutFiltering API
  createScoutFiltering ({commit}, data) {
    auth.createScoutFiltering(data)
      .then((d) => {
        commit('CREATE_SF', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getScoutFiltering ({commit}, id) {
    auth.getScoutFiltering(id)
      .then((d) => {
        commit('GET_SF', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateScoutFiltering ({commit}, data) {
    auth.updateScoutFiltering(data)
      .then((d) => {
        commit('UPDATE_SF', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteScoutFiltering ({commit}, id) {
    auth.deleteScoutFiltering(id)
      .then((d) => {
        commit('DELETE_SF', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // ScoutAutoSending API
  createScoutAutoSending ({commit}, data) {
    auth.createScoutAutoSending(data)
      .then((d) => {
        commit('CREATE_SAS', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getScoutAutoSending ({commit}, id) {
    auth.getScoutAutoSending(id)
      .then((d) => {
        commit('GET_SAS', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateScoutAutoSending ({commit}, data) {
    auth.updateScoutAutoSending(data)
      .then((d) => {
        commit('UPDATE_SAS', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteScoutAutoSending ({commit}, id) {
    auth.deleteScoutAutoSending(id)
      .then((d) => {
        commit('DELETE_SAS', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  getStatusAPI ({commit}, uuid) {
    return auth.getStatusAPI(uuid)
      .then((d) => {
        return d.data
      })
      .catch(()=> {
        return {
          type: 'no api',
          status: 'error'
        }
      })
  },
  getUsersStatusAPI ({commit}) {
    return auth.getUsersStatusAPI()
    .then((d) => {
      commit('GET_USERS_STATUS_API', d.data)
      return d.data
    })
    .catch(()=> {
      return {
        type: 'no api',
        status: 'error'
      }
    })
  },
  async getSelectedUsersStatusAPI ({commit}, data) {
    return await auth.getSelectedUsersStatusAPI(data)
    .then((d) => {
      return d.data
    })
    .catch(()=> {
      return {
        type: 'no api',
        status: 'error'
      }
    })
  },
  getCompanyAny ({commit}, cid) {
    return auth.getCompanyAny(cid)
      .then((d) => {
        return d.data
      })
      .catch(()=> {
        return {
          company_name: null,
          company_url: null
        }
      })
  },
  // ユーザーのインポート
  importUser ({commit}, data) {
    return auth.importUser(data)
      .then((d) => {
        return
      })
      .catch((e) => {
        console.error(e)
        alert('インポートに失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
      })
  },
  // 情報のエクスポート
  exportDepartment ({commit}) {
    return auth.exportDepartment()
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error(e)
        alert('エクスポートに失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
        return
      })
  },
  exportPosition ({commit}) {
    return auth.exportPosition()
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error(e)
        alert('エクスポートに失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
        return
      })
  },
  exportUser ({commit}) {
    return auth.exportUser()
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error(e)
        alert('エクスポートに失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
      })
  },
  sendEmailSeminarView ({commit}, data) {
    auth.sendEmailSeminarView(data)
  },
  payperuseInfo ({commit}) {
    auth.payperuseInfo()
      .then((d) => {
        commit('PAYPERUSE_INFO', d.data)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  billingDownload () {
    return auth.billingDownload()
      .then((d) => {
        var element = document.createElement('a')
        var blob = new Blob([d.request.response], {type: d.headers["Content-Type"]})
        element.href = window.URL.createObjectURL(blob)
        element.download = '請求書.pdf'
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
        return d.data
      })
  },
  // CompanyHomePage API
  createCompanyHomePage ({commit}, data) {
    auth.createCompanyHomePage(data)
      .then((d) => {
        commit('CREATE_CHP', d.data)
      })
      .catch((e) => {
        alert('エラーが発生いたしました。')
      })
  },
  getCompanyHomePage ({commit}, id) {
    auth.getCompanyHomePage(id)
      .then((d) => {
        commit('GET_CHP', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  updateCompanyHomePage ({commit}, data) {
    auth.updateCompanyHomePage(data)
      .then((d) => {
        commit('UPDATE_CHP', d.data)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCompanyHomePage ({commit}, id) {
    auth.deleteCompanyHomePage(id)
      .then((d) => {
        commit('DELETE_CHP', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteGaroon () {
    auth.deleteGaroon()
      .then (() => {
        alert('ガルーンとの連携を解除いたしました。一度リロードします。')
        location.reload()
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteLineWorks () {
    auth.deleteLineWorks()
      .then (() => {
        alert('LINE WORKSとの連携を解除いたしました。一度リロードします。')
        location.reload()
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteCybozuOffice () {
    auth.deleteCybozuOffice()
      .then (() => {
        alert('サイボーズオフィスとの連携を解除いたしました。一度リロードします。')
        location.reload()
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // UserCustomColumns API
  createUserCustomColumns({ commit }, data) {
    commit('LOAD_USER_CUSTOM', true)
    auth
      .createUserCustomColumns(data)
      .then((d) => {
        console.error(d)
        commit('CREATE_UCOL', { email: data.email, data: JSON.parse(d.data) })
        commit('LOAD_USER_CUSTOM', false)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
        commit('LOAD_USER_CUSTOM', false)
      })
  },
  getUserCustomColumns({ commit }, id) {
    auth
      .getUserCustomColumns(id)
      .then((d) => {
        commit('GET_UCOL', JSON.parse(d.data))
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  async updateUserCustomColumns({ commit }, data) {
    if (!Array.isArray(data)) data = [data]
    await auth
      .updateUserCustomColumns(data)
      .then((d) => {
        let columns = JSON.parse(d.data)
        for (let column of columns) commit('UPDATE_UCOL', { id: column.id, data: column })
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  deleteUserCustomColumns({ commit }, id) {
    auth
      .deleteUserCustomColumns(id)
      .then((d) => {
        commit('DELETE_UCOL', id)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
  },
  // DetailSheet API
  getDetailSheetTemplateList({commit}) {
    return auth.getDetailSheetTemplateList()
  },
  setDetailSheetTemplateList({commit}, data) {
    return auth.setDetailSheetTemplateList(data)
  },
  getDetailSheetColumnList({commit}, template_id) {
    return auth.getDetailSheetColumnList(template_id)
  },
  setDetailSheetColumnList({commit}, {template_id, data}) {
    return auth.setDetailSheetColumnList(template_id, data)
  },
  sendControlLog({commit}, data) {
    return auth.createControlLog(data)
      .then(() => {})
      .catch((e) => {})
  },
  getControlLogList({commit, state}, filter) {
    return auth.getControlLogList(filter)
      .then((d) => {
        const logs = JSON.parse(d.data)
        if (logs.length == 0) commit('setControlLogComplete', true)
        commit('addControlLogs', logs)
        commit('setControlLogLoading', false)
      })
      .catch((e) => {})
  },
  exportControlLogs({commit}, filter) {
    return auth.exportControlLogs(filter)
      .then((d) => {
        let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        let blob = new Blob([bom, d.data], { "type" : "text/csv" })
        let downLoadLink = document.createElement('a')
        downLoadLink.download = 'controlLogs.csv'
        downLoadLink.href = URL.createObjectURL(blob)
        downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
        downLoadLink.click()
      })
      .catch((e) => {})
  },
  getControlLogFilterItems({commit}) {
    return auth.getControlLogFilterItems()
      .then((d) => {commit('setControlLogFilterItems', JSON.parse(d.data))})
      .catch((e) => {})
  },
  loginResetRequest({commit}, payload) {
    return auth.loginResetRequest(payload)
      .then(result => {
        return result.data
      })
  },
  getLoginResetUser ({commit}, user_id) {
    return auth.getLoginResetUser(user_id)
      .then((result) => {
        return JSON.parse(result.data)
      })
      .catch(() => {
        return null
      })
  },
  login_reset ({commt}, user_id) {
    return auth.login_reset(user_id)
      .then(() => {
        return true
      })
      .catch(() => {
        return false
      })
  },
  async omitRecentApplicantDupflg({ commit }, { company_id, value }) {
    try {
      const data = { recent_applicant_dupflg: value };
      const response = await auth.omitRecentApplicantDupflg(company_id, data);
      commit('OMIT_RECENT_APPLICANT_DUPFLG', response.data.recent_applicant_dupflg);
    } catch (error) {
      console.error('Error in omitRecentApplicantDupflg:', error);
    }
  },
  async fetchRecentApplicantDupflg({commit}, company_id) {
    try {
      const response = await auth.getRecentApplicantDupflg(company_id);
      console.log('Response data:', response.data); // レスポンスデータの構造を確認
      commit('SET_RECENT_APPLICANT_DUPFLG', response.data.recent_applicant_dupflg);
    } catch (error) {
      alert("エラーが発生しました");
      console.error('Error in fetchRecentApplicantDupflg:', error);
    }
  },
}

const mutations = {
  [LOGIN_BEGIN] (state) {
    state.authenticating = true
    state.error = false
  },
  [LOGIN_FAILURE] (state,msg) {
    state.authenticating = false
    state.error = true
    if(!msg) msg="ログインエラー"
    console.error("MSG:"+msg)
    state.errorMessage = msg
    localStorage.setItem(TOKEN_STORAGE_KEY, '')
    localStorage.setItem(IS_CLIENT, '')
    localStorage.setItem(IS_USER, '')
  },
  [LOGIN_SUCCESS] (state) {
    state.authenticating = false
    state.error = false
  },
  [LOGOUT] (state, step) {
    if (step==1) {
      state.authenticating = false
      state.error = false
    }
    if (step==2) {
      localStorage.clear()
    }
  },
  [SET_TOKEN] (state, {token, is_client, is_user}) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token)
    localStorage.setItem(IS_CLIENT, is_client ? 'true' : 'false')
    localStorage.setItem(IS_USER, is_user ? 'true' : 'false')
    session.defaults.headers.Authorization = `JWT ${token}`
    session.defaults.withCredentials = true
    state.token = token
    state.isUser = is_user
    state.isClient = is_client
  },
  [REMOVE_TOKEN] (state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY)
    localStorage.removeItem(IS_CLIENT)
    localStorage.removeItem(IS_USER)
    delete session.defaults.headers.Authorization
    session.defaults.withCredentials = true
    state.token = null
    state.isUser = false
    state.isClient = false
  },
  [USER_SUCCESS] (state, data) {
    state.user = data.data
    for (var i in data.data.profileSeeker_info) {
      localStorage.setItem('SID_' + data.data.profileSeeker_info[i].ckey, data.data.profileSeeker_info[i].sessionid)
      localStorage.setItem('CNT_' + data.data.profileSeeker_info[i].ckey, data.data.profileSeeker_cnt[i].cnt)
    }
  },
  [CLIENT_SUCCESS] (state, data) {
    var head = '<input type="hidden" id="ndrkey" name="ndrkey" value="'
    var id = data.data.companyID
    var version = '' + new Date().getFullYear() + (new Date().getMonth() + 1) + new Date().getDate()
    var mid = '"><script id="stork-widget">(function(){var script=document.createElement("script");script.async = true;script.src="'
    var target = process.env.WDT_ENDPOINT + '/wdt/widget.js' + '?' + version
    var tail = '";var entry=document.getElementsByTagName("script")[0];entry.parentNode.insertBefore(script,entry);})();</script>'
    state.snippets = head + id + mid + target + tail
    localStorage.setItem('_user_c', id)
    state.user = data.data
    state.color = data.data.color
    state.power = data.data.power
    state.recent_applicant_dupflg = data.data.recent_applicant_dupflg
    // web push 周り
    // ブラウザが通知をサポートしているか確認する
    /*
    if (!('Notification' in window)) {
      alert('未対応のブラウザです')
    } else {
      // 許可を求める
      Notification.requestPermission()
        .then((permission) => {
          if (permission === 'granted') {
            // 許可
            console.log('======= 許可！！ ======')
          } else if (permission === 'denied') {
            // 拒否
            console.log('======= 拒否！！ ======')
          } else if (permission === 'default') {
            // 無視
            console.log('======= 無視！！ ======')
          }
        })
    }
    */
  },
  [GET_USERS] (state) {
    state.getUserWaiting = true
    auth.getUsers()
      .then((d) => {
        state.users = d.data.users
      })
      .finally(() => {
        state.getUserWaiting = false
      })
  },
  [SET_USERS] (state, data) {
    state.users = data.users
  },
  [SET_DEACTIVATED_USERS] (state, data) {
    state.deactivated_users = data
  },
  setUser (state, data) {
    state.user = data
  },
  setUpdatingStatus (state, status) {
    /**
     * 更新ステータス設定
     * @param {Number} status - 0: 更新中, 1: 成功, 2: 失敗
     */
    state.isUpdating = (status == 0 ? true : false)
    state.success = (status == 1 ? true : false)
    state.error = (status == 2 ? true : false)
  },
  [PROFILE_IMAGE] (state, data) {
    state.success = false
    state.error = false
    state.isUpdating = true
    auth.companyPageSave(data)
      .then((d) => {
        state.success = true
        state.error = false
        state.isUpdating = false
      })
      .catch((e) => {
        state.success = false
        state.error = true
        state.isUpdating = false
      })
  },
  [PROFILE_SET_U] (state, type) {
    state.success = true
    state.error = false
    state.isUpdating = false
    if (type=='user_pw') {
      state.pwChanged = 'ok'
    }
  },
  PROFILE_SET_U_ERROR (state, type) {
    if (type=='user_pw') {
      state.pwChanged = 'bad'
    }
    state.success = false
    state.error = true
    state.isUpdating = false
  },
  SET_USER_ICON (state, data) {
    state.user.profileIcon = data.profileIcon
  },
  [SET_USER_CONNECT] (state, data) {
    auth.setUserConnect(data)
      .then((d) => {
        console.log(d)
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [SET_SLACK] (state, {code, sec, on}) {
    auth.setSlack(code, state.user.companyID, sec, on)
      .then((d) => {
        state.slack = d.data
        state.slack.isSlackLink = true
        d.data.notify_flg === 'on' ? state.slack.on = true : state.slack.on = false
        location.href = process.env.OWN_ENDPOINT + '/dashboard/setting/other_api'
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [SAVE_SLACK] (state, slack) {
    auth.updateSlack(slack)
      .then((d) => {
        state.slack = slack
        alert('保存しました。')
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        alert('保存時にエラーが発生いたしました。')
      })
  },
  [GET_SLACK] (state) {
    state.isSlackandCW = false
    auth.getSlack(state.user.companyID)
      .then((d) => {
        if (d.data.team != null) {
          state.slack = d.data
          d.data.notify_flg === 'on' ? state.slack.on = true : state.slack.on = false
          state.slack.isSlackLink = true
        }
        state.isSlackandCW = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.slack.isSlackLink = false
        state.isSlackandCW = true
      })
  },
  [POST_SLACK] (state, {companyID, seekerID, msg}) {
    auth.postSlack(companyID, seekerID, msg)
      .then((d) => {
        console.log(d)
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [DELETE_SLACK_LINK] (state) {
    auth.deleteSlackLink()
      .then((d) => {
        state.slack.team = ''
        state.slack.channel = ''
        state.slack.sec = ''
        state.slack.isSlackLink = false
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [SET_CW] (state, {code, sec, on}) {
    auth.setCW(code, state.user.companyID, sec, on)
      .then((d) => {
        state.cw.roomName = d.data.roomName
        state.cw.roomID = d.data.roomID
        state.cw.sec = d.data.triger_sec
        state.cw.isCWLink = true
        d.data.notify_flg === 'on' ? state.cw.on = true : state.cw.on = false
        state.cwRooms = d.data.rooms
        location.href = process.env.OWN_ENDPOINT + '/dashboard/setting/other_api'
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [PUT_CW] (state, {rid, rname}) {
    var data = {'rid': rid, 'rname': rname}
    auth.putCW(data)
      .then((d) => {
        state.cw.roomID = rid
        state.cw.roomName = rname
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [GET_CW] (state) {
    auth.getCW(state.user.companyID)
      .then((d) => {
        if (!d.data.status) {
          state.cw = d.data
          state.cw.isCWLink = true
          state.cwRooms = d.data.cwRooms
        } else {
          state.cw.isCWLink = false
        }
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.cw.isCWLink = false
      })
  },
  [POST_CW] (state, {companyID, seekerID, msg}) {
    auth.postCW(companyID, seekerID, msg)
      .then((d) => {
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
    },
  [SAVE_CW] (state, cw) {
    auth.updateCW(cw)
      .then((d) => {
        state.cw = cw
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [DELETE_CW_LINK] (state) {
    auth.deleteCWLink()
      .then((d) => {
        state.cw.access_token = null
        state.cw.roomName = ''
        state.cw.sec = ''
        state.cw.isCWLink = false
        alert('解除しました。リロードします。')
        location.reload()
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [GET_WT] (state) {
    auth.getWT(state.user.companyID)
      .then((d) => {
        state.wt = d.data
        state.isWowTalk = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isWowTalk = false
      })
  },
  [PUT_WT] (state, wt) {
    auth.putWT(wt)
      .then((d) => {
        state.isWowTalk = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isWowTalk = false
      })
  },
  [POST_WT] (state, {companyID, seekerID, msg}) {
    auth.postWT(companyID, seekerID, msg)
      .then((d) => {
        console.log(d)
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [POST_WT_LINK] (state, wt) {
    wt['company_key'] = state.user.companyID
    auth.postWTLink(wt)
      .then((d) => {
        state.isWowTalk = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isWowTalk = false
      })
  },
  [DELETE_WT_LINK] (state) {
    auth.deleteWTLink()
      .then((d) => {
        state.wt.api_key = ''
        state.wt.department_name = ''
        state.wt.subscribe_room_name = ''
        state.wt.is_subscribe = false
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [NOW_LOADING] (state) {
    state.isLoading = true
  },
  [ADD_MEMBER] (state, data) {
    state.error = false
    state.success = false
    auth.addMember(data)
      .then((d) => {
        state.success = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.error = true
        if (e.response.data.error_message) {
          state.errorMessage = e.response.data.error_message
        } else {
          state.errorMessage = 'エラー：メールを送信できませんでした。'
        }
      })
  },
  [READD_MEMBER] (state, data) {
    state.error = false
    state.success = false
    auth.reAddMember(data)
      .then((d) => {
        state.success = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.error = true
      })
  },
  [SET_COLOR] (state, color) {
    state.error = false
    auth.setColor({
      'icon_bgcolor': color.iconBg,
      'icon_frcolor': color.iconFr,
      'icon_balloonColor': color.iconBallon,
      'icon_msgColor': color.iconMsg,
      'header_color': color.header,
      'balloon_myColor': color.balloonMy,
      'balloon_otrColor': color.balloonOtr,
      'send_color': color.sendBtn,
      'shape_type': color.shapeType,
      'shadow_type': color.shadowType,
      'input_type': color.inputType,
      'header_type': color.headerType,
      'categorymenu_type': color.categorymenuType,
      'animation_type': color.animationType,
      'staffbot_type': color.staffbotType,
      'icon_template': color.template,
      'view_template': color.view_template,
      'mobile_vertical_position': color.mobile_vertical_position,
      'pc_vertical_position': color.pc_vertical_position,
      'mobile_horizontal_position': color.mobile_horizontal_position,
      'pc_horizontal_position': color.pc_horizontal_position,
      'mobile_offset_up': color.mobile_offset_up,
      'pc_offset_up': color.pc_offset_up,
      'mobile_offset_left': color.mobile_offset_left,
      'pc_offset_left': color.pc_offset_left,
      'thinking_rate': color.thinking_rate,
      'register_icon_type': color.register_icon_type,
      'custom_msg': color.customMsg,
      'icon_height': color.iconHeight,
      'icon_width': color.iconWidth,
      'icon_radius': color.iconRadius,
      'show_minimize_button': color.showMinimizeButton,
    })
      .then((d) => {
        state.color = color
        state.success = true
        alert('反映しました')
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.error = true
        alert('エラーが発生しました')
      })
    state.error = false
    state.success = false
  },
  [SET_POWER] (state, power) {
    auth.setPower({
      'power': power ? 1 : 0
    })
      .then((d) => {
        state.power = power
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.power = power
      })
  },
  [ADD_CARD] (state, {type, text}) {
    auth.createCard({
      'type': type,
      'text': text
    })
      .then((d) => {
        state.user.cards.push({
          'id': d.data.id,
          'type': d.data.type,
          'text': d.data.text,
          'editable': false
        })
      })
  },
  [SET_CARD] (state, {id, type, text, index}) {
    auth.setCard({
      'card_id': id,
      'type': type,
      'text': text
    })
      .then((d) => {
        state.user.cards.splice(index, 1, {
          'id': id,
          'type': type,
          'text': text,
          'editable': false
        })
      })
  },
  [SET_CARDS_ORDER] (state, cards) {
    auth.setCardsOrder({ 'cards': cards })
      .then((d) => {
        state.user.cards = d.data
      })
  },
  [EDIT_CARD] (state, data) {
    state.user.cards[data].editable = true
  },
  [DELETE_CARD] (state, {id, type, text, isDelete, index}) {
    auth.setCard({
      'card_id': id,
      'type': type,
      'text': text,
      'is_delete': true
    })
      .then((d) => {
        state.user.cards.splice(index, 1)
      })
  },
  [SET_RH_MODAL] (state) {
    state.isModalRequestHelp = !state.isModalRequestHelp
  },
  [SEND_RH] (state, data) {
    auth.sendRH(data)
      .then((d) => {
        state.isModalRequestHelp = false
      })
      .catch(() => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [SET_PR_MODAL] (state) {
    state.isModalPasswordReset = !state.isModalPasswordReset
  },
  [SEND_PR] (state, data) {
    auth.sendPR(data)
      .then((d) => {
        state.isModalPasswordReset = false
        state.isEmailSent = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isEmailSent = false
      })
  },
  [CHK_TKN] (state, id) {
    state.isResetTokenExpired = false
    state.isResetTokenLoading = true
    auth.checkToken(id)
      .then((d) => {
        state.isResetTokenExpired = d.data.isCheck
        state.isResetTokenLoading = false
      })
      .catch(() => {
        console.error('e: ' + JSON.stringify(e))
        state.isResetTokenExpired = false
        state.isResetTokenLoading = false
      })
  },
  [RE_ISSUE] (state, id) {
    state.finishReIssue = false
    auth.reIssue(id)
    .then((d) => {
      state.finishReIssue = true
    })
    .catch((e) => {
      console.error('e: ' + JSON.stringify(e))
      alert('再発行できませんでした。')
      state.finishReIssue = false
    })
  },
  [RE_CREATE_PASS] (state, {password, id}) {
    state.error = false
    state.success = false
    var data = {'password': password}
    auth.reCreatePassword(data, id)
      .then((d) => {
        state.success = d.data.isCheck
        state.error = !d.data.isCheck
      })
      .catch(() => {
        console.error('e: ' + JSON.stringify(e))
        state.error = true
      })
  },
  [GET_COMPANY_LIST] (state) {
    auth.getCompanyList()
      .then((d) => {
        state.companyList = d.data
      })
      .catch(() => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [SET_USER_COMPANY] (state, companyID) {
    // TODO: なぜかJSONになってしまう（頭が働く時に考える）
    auth.updateUserCompany(companyID['companyID'])
      .then(() => {
        location.href = process.env.OWN_ENDPOINT + '/dashboard/manage'
      })
      .catch(() => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [GOOGLE_AUTH_REVOKE] (state) {
    auth.googleAuthRevoke(state.user.email)
      .then(() => {
        alert('連携を解除しました。再読み込みします。')
        location.reload()
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  SEND_LOGIN_RESET (state, data) {
    auth.loginResetRequest(data)
      .then((d) => {
        console.log('data: ', data.data)
        state.isModalLoginReset = false
        state.isEmailSent = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isEmailSent = false
      })
  },
  GET_GOOGLE_DRIVE_AUTH_STATUS (state, status) {
    state.isGoogleDriveAuth = (status == 'Authorized')
  },
  MSOFFICE_AUTH_REVOKE (state) {
    console.log('end revoke - msoffice')
    alert('連携を解除しました。再読み込みします。')
    location.reload()
  },
  SET_LINE_CHANNEL_INFO (state, has_line_channel) {
    state.user.has_line_channel = has_line_channel
  },
  [SET_ICON_IMG] (state, {name, data}) {
    state.isLoading = true
    auth.setIconImage(name, data.replace(/^.*,/, ''))
      .then((d) => {
        state.color.iconImage = d.data.iconImage
        state.isLoading = false
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
      })
  },
  [GET_QUERY] (state,name) {
    if (name['urltype'] == 'direct'){
      state.query_url_direct = name['name']
    }
    if (name['urltype'] == 'chat'){
      state.query_url_chat = name['name']
    }
  },  
  [GET_QUERY_DELET] (state,data) {
    if (data == 'direct'){
      state.query_url_direct = null
    }
    if (data == 'chat'){
      state.query_url_chat = null
    }
  },    
  [GET_SEARCH] (state, searchWord) {
    if (!(searchWord == undefined)){ 
      auth.getSearch(searchWord)
        .then((d) => {
            state.isModalRequestHelpSearch = !state.isModalRequestHelpSearch
          var checkResult =  d.data.noresult
          if (checkResult == 0 ){
            state.searchResult.noResult = true
          }else{
            state.searchResult.noResult = false         
          }
          state.searchResult.filed = d.data.filed
          state.searchResult.record = d.data.record
          state.searchResult.serachword = searchWord 
        })
        .catch((e) => {
            console.error('e: ' + JSON.stringify(e))
            alert('ERR GET_SEARCH: \n' + e)
          })
      }
  },
  async [SEND_SBSCB] (state, data) {
    return await auth.sendSubscribe(data)
      .catch((e) => {
        console.error(e)
      })
  },
  [DEMO_IMAGE] (state, data) {
    state.isDemoLoading = true
    auth.demoImage(data)
      .then((d) => {
        state.demoImage = d.data.image
        state.isGetImage = true
        state.isDemoLoading = false
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isDemoLoading = false
      })
  },
  [SEND_CV] (state, data) {
    state.isSendCVLoading = true
    auth.sendMessage(data)
      .then((d) => {
        state.isSendCVLoading = false
        state.isSendCVSended = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isSendCVLoading = false
        alert('メール送信中にエラーが発生いたしました。しばらくしてから再送信お願いいたします。')
      })
  },
  async [SEND_CV_NO](state, data) {
    state.isSendCVLoading = true
    return await auth.sendSubscribeNoData(data)
      .then((d) => {
        state.isSendCVLoading = false
        state.isSendCVSended = true
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isSendCVLoading = false
        alert('メール送信中にエラーが発生いたしました。しばらくしてから再送信お願いいたします。')
      })
  },
  [SET_TOP] (state, data) {
    auth.createTopLPUser(data)
    .then((d) => {
      console.log(d)
    })
    .catch((e) => {
      console.error('e: ' + JSON.stringify(e))
    })
  },
  GET_VIDEO_INFO (state, id) {
    auth.getVideoInterviewInfo(id)
      .then((d) => {
        state.videoInterviewInfo = d.data
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        state.isErrorVideoInterviewInfo = true
      })
  },
  [GET_CATEGORY] (state, data) {
    state.storeCategory = data
  },
  [PUT_CATEGORY] (state, data) {
    state.storeCategory = data
  },
  [POST_CATEGORY] (state, data) {
    state.storeCategory = data
  },
  [DELETE_CATEGORY] (state, id) {
    for (var idx in state.storeCategory) {
      if (state.storeCategory[idx].category_id == id) {
        state.storeCategory.splice(idx, 1)
      }
    }
  },
  [OMIT_RECENT_APPLICANT_DUPFLG](state, recentApplicantDupflg) {
    state.recent_applicant_dupflg = recentApplicantDupflg;
  },  
  [SET_RECENT_APPLICANT_DUPFLG](state, recentApplicantDupflg) {
    console.log('Mutation data:', recentApplicantDupflg);
    state.recentApplicantDupflg = recentApplicantDupflg;
  },
  CHANGE_SHAPE(state, payload) {
    state.color.customMsg = payload.customMsg
    state.color.iconHeight = payload.iconHeight  + 'px'
    state.color.iconWidth = payload.iconWidth  + 'px'
    state.color.iconRadius = payload.iconRadius + 'px'
  },
  CHANGE_ICON_HEIGHT (state, payload) {
    state.color.iconHeight = payload + 'px'
  },
  CHANGE_ICON_WIDTH (state, payload) {
    state.color.iconWidth = payload + 'px'
  },
  CHANGE_ICON_RADIUS (state, payload) {
    state.color.iconRadius = payload + 'px'
  },
  // Company Recruit API
  CREATE_CREC (state, data) {
    state.companyRecruit.push(data)
  },
  CREATE_DCREC (state, data) {
    const delete_manageid = state.default_manage.pk
    const delete_index = data.manage_id.findIndex((value)  => {
      return value === delete_manageid
    })
    const removedmanages = data.manage_id.splice(delete_index, 1)
    state.displaycompanyRecruit.push(data)
  },
  GET_CREC (state, data) {
    state.companyRecruit = data
  },
  GET_DCREC (state, data) {
    state.displaycompanyRecruit = data
  },
  GET_MEDIA_COOPE_LIST (state, data) {
    state.mediaCooperationList = data
  },
  UPDATE_CREC (state, data) {
    for (let i in state.companyRecruit) {
      if (state.companyRecruit[i].pk == data.pk) {
        state.companyRecruit.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_CREC (state, id) {
    for (let i in state.companyRecruit) {
      if (state.companyRecruit[i].pk == id) {
        state.companyRecruit.splice(i, 1)
      }
    }
    for (let n in state.displaycompanyRecruit) {
      if (state.displaycompanyRecruit[n].pk == id) {
        state.displaycompanyRecruit.splice(n, 1)
      }
    }
    return
  },
  // Email Template API
  CREATE_CETEMP (state, data) {
    state.emailTemplates.push(data)
  },
  GET_CETEMP (state, data) {
    state.emailTemplates = data
  },
  UPDATE_CETEMP (state, data) {
    for (let i in state.emailTemplates) {
      if (state.emailTemplates[i].pk == data.pk) {
        state.emailTemplates.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_CETEMP (state, id) {
    for (let i in state.emailTemplates) {
      if (state.emailTemplates[i].pk == id) {
        state.emailTemplates.splice(i, 1)
        return
      }
    }
  },
  UPDATE_ORDERCETEMPAL (state, data) {
    data['service'] == 'Email' ? state.emailTemplates = data['temp'] : state.SMSTemplates = data['temp']
  },
  // Email(SMS) Template API
  CREATE_CSTEMP (state, data) {
    state.SMSTemplates.push(data)
  },
  GET_CSTEMP (state, data) {
    state.SMSTemplates = data
  },
  UPDATE_CSTEMP (state, data) {
    for (let i in state.SMSTemplates) {
      if (state.SMSTemplates[i].pk == data.pk) {
        state.SMSTemplates.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_CSTEMP (state, id) {
    for (let i in state.SMSTemplates) {
      if (state.SMSTemplates[i].pk == id) {
        state.SMSTemplates.splice(i, 1)
        return
      }
    }
  },
  // CompanyColumnSetting API
  CREATE_CCOL (state, data) {
    state.companyColumnSetting.push(data)
  },
  GET_CCOL (state, data) {
    for (let i in data) {
      data[i].order_type = Number(i)
    }
    state.companyColumnSetting = data
  },
  UPDATE_CCOL (state, data) {
    if (!Array.isArray(data)) data = [data]
    for (let i in state.companyColumnSetting) {
      for (let j in data) {
        if (state.companyColumnSetting[i].pk == data[j].pk) {
          state.companyColumnSetting.splice(i, 1, data[j])
          continue
        }
      }
    }
  },
  DELETE_CCOL (state, id) {
    for (let i in state.companyColumnSetting) {
      if (state.companyColumnSetting[i].pk == id) {
        state.companyColumnSetting.splice(i, 1)
        return
      }
    }
  },
  // CompanyPulldownColumn API
  // 新しいプルダウンカラムを追加
  ADD_PULLDOWN_COLUMN(state, newPulldownColumn) {
    state.companyPulldownColumns.push(newPulldownColumn);
  },
  // プルダウンオプションを設定
  SET_PULLDOWN_OPTIONS(state, payload) {
    if (payload.columnId !== undefined) {
      // payloadがオブジェクトの場合（新しい要件）
      state.pulldownOptions = {
        ...state.pulldownOptions,
        [payload.columnId]: payload.tempPulldownColumnOptions
      };
    } else {
      // payloadが直接optionsの場合（既存の動作）
      state.pulldownOptions = payload;
    }
  },
  // プルダウンカラムを更新
  UPDATE_PULLDOWN_COLUMN(state, data) {
    const index = state.companyPulldownColumns.findIndex(column => column.id === data.id);
    if (index !== -1) {
      state.companyPulldownColumns.splice(index, 1, data);
    }
  },
  // プルダウンオプションを更新
  UPDATE_PULLDOWN_OPTIONS(state, { columnId, options }) {
    state.pulldownOptions = {
      ...state.pulldownOptions,
      [columnId]: options
    };
  },
  // プルダウンカラムを削除
  DELETE_PULLDOWN_COLUMN(state, id) {
    state.companyPulldownColumns = state.companyPulldownColumns.filter(column => column.id !== id);
  },
  // UserCustomColumns API
  CREATE_UCOL(state, data) {
    for (let i in state.users) {
      if (state.users[i].email === data.email) {
        state.users[i].u_custom.push(data.data)
        return
      }
    }
  },
  GET_UCOL(state, data) {
    console.log(data)
    state.userCustomColumns = data
  },
  UPDATE_UCOL(state, data) {
    for (let i in state.users) {
      if (state.users[i].email === data.email) {
        for (let j in state.users[i].u_custom) {
          if (state.users[i].u_custom[j].pk === data.data.pk) {
            state.users[i].u_custom.splice(j, 1, data.data)
            return
          }
        }
      }
    }
  },
  DELETE_UCOL(state, id) {
    for (let i in state.users) {
      for (let j in state.users[i].u_custom) {
        if (state.users[i].u_custom[j].pk === id) {
          state.users[i].u_custom.splice(j, 1)
          return
        }
      }
    }
  },
  LOAD_USER_CUSTOM(state, flg) {
    state.isSavingUserCustomColumn = flg
  },
  // Scout API
  CREATE_SCT (state, data) {
    state.scouts.push(data)
  },
  GET_SCT (state, data) {
    state.scouts = data
  },
  UPDATE_SCT (state, data) {
    for (let i in state.scouts) {
      if (state.scouts[i].pk == data.pk) {
        state.scouts.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_SCT (state, id) {
    for (let i in state.scouts) {
      if (state.scouts[i].pk == id) {
        state.scouts.splice(i, 1)
        return
      }
    }
  },
  // RecruitmentFlow API
  INIT_RF_START (state) {
    state.isInitCreatingRecruitmentFlow = true
  },
  INIT_RF_END (state) {
    state.isInitCreatingRecruitmentFlow = false
  },
  CREATE_RF (state, data) {
    state.recruitmentFlows.push(data)
  },
  GET_RF (state, data) {
    state.recruitmentFlows = data
    // console.log(state.recruitmentFlows)
    for(let i in state.recruitmentFlows){
      // console.log(state.recruitmentFlows[i])
      for(let c in state.recruitmentFlows[i].stages){
        const stage = state.recruitmentFlows[i].stages[c];
        if (!stage.is_delete_apply) {
          const isDuplicate = state.recruitmentFlowStages.some(existingStage => existingStage.pk === stage.pk);
          if (!isDuplicate) {
            state.recruitmentFlowStages.push(stage);
          }
        }
        // console.log(state.recruitmentFlows[i].stages[c])
        for(let d in state.recruitmentFlows[i].stages[c].status){
          const status = state.recruitmentFlows[i].stages[c].status[d];
          if(!status.is_delete_apply){
            const isDuplicate = state.recruitmentFlowStatus.some(existingStatus => existingStatus.pk === status.pk);
            if (!isDuplicate) {
              state.recruitmentFlowStatus.push(status);
            }
          }
          // console.log(state.recruitmentFlows[i].stages[c].status[d])
          for (let e in state.recruitmentFlows[i].stages[c].status[d].actions) {
            const action = state.recruitmentFlows[i].stages[c].status[d].actions[e];
            const isDuplicate = state.recruitmentFlowActions.some(existingAction => existingAction.pk === action.pk);          
            if (!isDuplicate) {
              state.recruitmentFlowActions.push(action);
            }
          }
        }
      }
    }
  },
  UPDATE_RF (state, data) {
    for (let i in state.recruitmentFlows) {
      if (state.recruitmentFlows[i].pk === data.pk) {
        state.recruitmentFlows.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_RF (state, id) {
    for (let i in state.recruitmentFlows) {
      if (state.recruitmentFlows[i].pk === id) {
        state.recruitmentFlows.splice(i, 1)
        return
      }
    }
  },
  // RecruitmentFlowStage API
  CREATE_RFSTG (state, data) {
    for (let rf of state.recruitmentFlows) {
      if (rf.pk === data.recruitment_flow) {
        rf.stages.push(data)
        return
      }
    }
  },
  GET_RFSTG (state, data) {
    state.recruitmentFlowStages = data
  },
  UPDATE_RFSTG (state, data) {
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        if (state.recruitmentFlows[i].stages[j].pk === data.pk) {
          state.recruitmentFlows[i].stages.splice(j, 1, data)
          return
        }
      }
    }
  },
  DELETE_RFSTG (state, id) {
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        if (state.recruitmentFlows[i].stages[j].pk === id) {
          state.recruitmentFlows[i].stages.splice(j, 1)
          return
        }
      }
    }
  },
  // CreateManage API
  CREATE_MNG (state, data) {
    state.manages.push(data)
    state.select_manages.push(data)
  },
  GET_MNG (state, data) {
    // データベースに存在するタブをすべて設定
    // （システムタブもデータベースに存在するはずなので、dataにすでに含まれている）
    state.manages = data
  },
  GET_SELECT_MNG (state, data) {
    // データをコピーしてから処理（元のデータを変更しない）
    const selectableManages = [...data]
    const delete_name = '応募者一覧'
    const delete_index = selectableManages.findIndex((n) => n.name === delete_name)
    if (delete_index !== -1) {
      selectableManages.splice(delete_index, 1)
    }
    state.select_manages = selectableManages
  },
  GET_DEFAULT_MNG(state, data) {
    const search_name = '応募者一覧'
    state.default_manage = data.find((n) => n.name === search_name)
  },
  SET_SYSTEM_TAB_NAMES(state, names) {
    state.system_tab_names = names
  },
  // UpdateManage API
  UPDATE_MNG (state, data) {
    const index = state.manages.findIndex(manage => manage.pk === data.pk)
    if (index !== -1) {
      state.manages.splice(index, 1, data)
    }
    const selectIndex = state.select_manages.findIndex(manage => manage.pk === data.pk)
    if (selectIndex !== -1) {
      state.select_manages.splice(selectIndex, 1, data)
    }
  },
  // DeleteManage API
  DELETE_MNG (state, id) {
    const index = state.manages.findIndex(manage => manage.pk === id)
    if (index !== -1) {
      state.manages.splice(index, 1)
    }
    const selectIndex = state.select_manages.findIndex(manage => manage.pk === id)
    if (selectIndex !== -1) {
      state.select_manages.splice(selectIndex, 1)
    }
  },
  // RecruitmentFlowStatus API
  // ループ多すぎるので、引数追加して、適切に変更する形とった方が良いかも
  CREATE_RFSTS (state, data) {
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        if (state.recruitmentFlows[i].stages[j].pk === data.recruitment_flow_stage) {
          state.recruitmentFlows[i].stages[j].status.push(data)
          return
        }
      }
    }
  },
  GET_RFSTS (state, data) {
    state.recruitmentFlowStatus = data
  },
  UPDATE_RFSTS (state, data) {
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        for (let k in state.recruitmentFlows[i].stages[j].status) {
          if (state.recruitmentFlows[i].stages[j].status[k].pk === data.pk) {
            state.recruitmentFlows[i].stages[j].status.splice(k, 1, data)
            return
          }
        }
      }
    }
  },
  DELETE_RFSTS (state, id) {
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        for (let k in state.recruitmentFlows[i].stages[j].status) {
          if (state.recruitmentFlows[i].stages[j].status[k].pk === id) {
            state.recruitmentFlows[i].stages[j].status.splice(k, 1)
            return
          }
        }
      }
    }
  },
  // RecruitmentFlowActions API
  // ループ多すぎるので、引数追加して、適切に変更する形とった方が良いかも
  CREATE_RFACT (state, data) {
    const processedData = { ...data };
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        for (let k in state.recruitmentFlows[i].stages[j].status) {
          if (state.recruitmentFlows[i].stages[j].status[k].pk === data.recruitment_flow_status) {
            state.recruitmentFlows[i].stages[j].status[k].actions.push(data)
            // フィルタリングのセレクトボックス用のstate
            state.recruitmentFlowActions.push(data)
            return
          }
        }
      }
    }
  },
  GET_RFACT (state, data) {
    // 配列の場合の処理
    if (Array.isArray(data)) {
      state.recruitmentFlowActions = data.map(item => {
        if (item.is_continuous) {
          return { ...item, type: item.type === 0 ? 3 : 4 };
        }
        return item;
      });
    } else {
      state.recruitmentFlowActions = data;
    }
  },
  UPDATE_RFACT (state, data) {
    // データの変換処理を追加
    const processedData = { ...data };
    if (processedData.is_continuous) {
      processedData.type = processedData.type === 0 ? 3 : 4;
    }
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        for (let k in state.recruitmentFlows[i].stages[j].status) {
          for (let l in state.recruitmentFlows[i].stages[j].status[k].actions) {
            if (state.recruitmentFlows[i].stages[j].status[k].actions[l].pk === data.pk) {
              state.recruitmentFlows[i].stages[j].status[k].actions.splice(l, 1, data)
              // フィルタリングのセレクトボックス用のstate
              const idx = state.recruitmentFlowActions.findIndex(({pk}) => pk === data.pk)
              state.recruitmentFlowActions.splice(idx, 1, data)
              console.log(state.recruitmentFlowActions)
              return
            }
          }
        }
      }
    }
  },
  DELETE_RFACT (state, id) {
    for (let i in state.recruitmentFlows) {
      for (let j in state.recruitmentFlows[i].stages) {
        for (let k in state.recruitmentFlows[i].stages[j].status) {
          for (let l in state.recruitmentFlows[i].stages[j].status[k].actions) {
            if (state.recruitmentFlows[i].stages[j].status[k].actions[l].pk === id) {
              state.recruitmentFlows[i].stages[j].status[k].actions.splice(l, 1)
              // フィルタリングのセレクトボックス用のstate
              const idx = state.recruitmentFlowActions.findIndex(({pk}) => pk === id)
              state.recruitmentFlowActions.splice(idx, 1)
              return
            }
          }
        }
      }
    }
  },
  GET_FOLLOW_INFO(state, data) {
    state.followDatas = data
  },
  GET_FOLLOW(state, data) {
    state.followState = data[0].follow_flg
  },
  ADD_FOLLOW(state, data) {
    state.followState = data.follow_active
  },
  DELETE_FOLLOW(state, data) {
    state.followState = data.follow_active
  },
  // Department API
  CREATE_DEPART (state, data) {
    state.departments.push(data)
  },
  GET_DEPART (state, data) {
    state.departments = data
  },
  UPDATE_DEPART (state, data) {
    for (let department of state.users) {
      for (let d of department["departments"]) {
        if (d.pk == data.pk) {
          d.name = data.name
        }
      }
    }
    for (let i in state.departments) {
      if (state.departments[i].pk == data.pk) {
        state.departments.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_DEPART (state, id) {
    for (let department of state.users) {
      for (let d in department["departments"]) {
        if (department["departments"][d].pk == id) {
          department["departments"].splice(d, 1)
        }
      }
    }
    for (let i in state.departments) {
      if (state.departments[i].pk == id) {
        state.departments.splice(i, 1)
        return
      }
    }
  },
  // Position API
  CREATE_POSITION (state, data) {
    state.positions.push(data)
  },
  GET_POSITION (state, data) {
    state.positions = data
  },
  UPDATE_POSITION (state, data) {
    for (let position of state.users) {
      for (let p of position["positions"]) {
        if (p.pk == data.pk) {
          p.name = data.name
        }
      }
    }
    for (let i in state.positions) {
      if (state.positions[i].pk == data.pk) {
        state.positions.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_POSITION (state, id) {
    for (let position of state.users) {
      for (let p in position["positions"]) {
        if (position["positions"][p].pk == id) {
          position["positions"].splice(p, 1)
        }
      }
    }
    for (let i in state.positions) {
      if (state.positions[i].pk == id) {
        state.positions.splice(i, 1)
        return
      }
    }
  },
  // CalendarBookMark API
  CREATE_CBM (state, data) {
    state.calendarBookMarks.push(data)
  },
  GET_CBM (state, data) {
    state.calendarBookMarks = data
  },
  UPDATE_CBM (state, data) {
    for (let i in state.calendarBookMarks) {
      if (state.calendarBookMarks[i].pk == data.pk) {
        state.calendarBookMarks.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_CBM (state, id) {
    for (let i in state.calendarBookMarks) {
      if (state.calendarBookMarks[i].pk == id) {
        state.calendarBookMarks.splice(i, 1)
        return
      }
    }
  },
  // UserCalendarSetting API
  CREATE_UCS (state, data) {
    state.calendarSettings.push(data)
  },
  GET_UCS (state, data) {
    state.calendarSettings = data
  },
  UPDATE_UCS (state, data) {
    for (let i in state.calendarSettings) {
      if (state.calendarSettings[i].pk == data.pk) {
        state.calendarSettings.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_UCS (state, id) {
    for (let i in state.calendarSettings) {
      if (state.calendarSettings[i].pk == id) {
        state.calendarSettings.splice(i, 1)
        return
      }
    }
  },
  // UserCalendarSettingDisplay（面接予定設定・変更時に空き時間を確認するためのカレンダー） API
  CREATE_UCSD (state, data) {
    state.calendarSettingsDisplay.push(data)
  },
  DELETE_UCSD (state, data) {
    for (let i in state.calendarSettingsDisplay) {
      if (state.calendarSettingsDisplay[i].user == data.user && state.calendarSettingsDisplay[i].calendar_user == data.calendar_user) {
        state.calendarSettingsDisplay.splice(i, 1)
        return
      }
    }
  },
  CLEAR_UCSD (state) {
    state.calendarSettingsDisplay = []
  },
  // UserCalendarEventHistory API
  CREATE_UCEH (state, data) {
    state.calendarEventHistory.push(data)
  },
  GET_UCEH (state, data) {
    state.calendarEventHistory = data
  },
  UPDATE_UCEH (state, data) {
    for (let i in state.calendarEventHistory) {
      if (state.calendarEventHistory[i].pk == data.pk) {
        state.calendarEventHistory.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_UCEH (state, id) {
    for (let i in state.calendarEventHistory) {
      if (state.calendarEventHistory[i].pk == id) {
        state.calendarEventHistory.splice(i, 1)
        return
      }
    }
  },
  // UserChatBotBookMark API
  CREATE_UCB (state, data) {
    state.userChatBotBookMark.push(data)
  },
  GET_UCB (state, data) {
    state.userChatBotBookMark = data
  },
  UPDATE_UCB (state, data) {
    for (let i in state.userChatBotBookMark) {
      if (state.userChatBotBookMark[i].pk == data.pk) {
        state.userChatBotBookMark.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_UCB (state, id) {
    for (let i in state.userChatBotBookMark) {
      if (state.userChatBotBookMark[i].pk == id) {
        state.userChatBotBookMark.splice(i, 1)
        return
      }
    }
  },
  // ScoutFiltering API
  CREATE_SF (state, data) {
    state.scoutFiltering.push(data)
  },
  GET_SF (state, data) {
    state.scoutFiltering = data
  },
  UPDATE_SF (state, data) {
    for (let i in state.scoutFiltering) {
      if (state.scoutFiltering[i].pk === data.pk) {
        state.scoutFiltering.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_SF (state, id) {
    for (let i in state.scoutFiltering) {
      if (state.scoutFiltering[i].pk === id) {
        state.scoutFiltering.splice(i, 1)
        return
      }
    }
  },
  // ScoutAutoSending API
  CREATE_SAS (state, data) {
    state.scoutAutoSending.push(data)
  },
  GET_SAS (state, data) {
    state.scoutAutoSending = data
  },
  UPDATE_SAS (state, data) {
    for (let i in state.scoutAutoSending) {
      if (state.scoutAutoSending[i].pk === data.pk) {
        state.scoutAutoSending.splice(i, 1, data)
        return
      }
    }
  },
  DELETE_SAS (state, id) {
    for (let i in state.scoutAutoSending) {
      if (state.scoutAutoSending[i].pk === id) {
        state.scoutAutoSending.splice(i, 1)
        return
      }
    }
  },
  GET_USERS_STATUS_API (state, data) {
    state.usersStatusAPI = data
  },
  PAYPERUSE_INFO (state, data) {
    state.payperuseInfoData = data
  },
  // CompanyHomePage API
  CREATE_CHP (state, data) {
    state.companyHomePages.push(data)
  },
  GET_CHP (state, data) {
    state.companyHomePages = data
  },
  UPDATE_CHP (state, data) {
    state.companyHomePages =
      state.companyHomePages.map((v) => v.id == data.id ? data : v)
  },
  DELETE_CHP (state, id) {
    state.companyHomePages =
      state.companyHomePages.filter((v) => v.id !== id )
  },
  addControlLogs(state, data) {
    state.controlLogs = state.controlLogs.concat(data)
  },
  initControlLogs(state) {
    state.controlLogs = []
  },
  setControlLogLoading(state, status) {
    state.controlLogLoading = status
  },
  setControlLogComplete(state, status) {
    state.controlLogComplete = status
  },
  setControlLogFilterItems(state, data) {
    state.controlLogFilterItems = data
  },
  setControlLogViewID(state, data) {
    state.controlLogViewID = data
  },
  setIsMessage (state){
    state.isMessageView = true
  },
  resetIsMessage (state){
    state.isMessageView = false
  },
  setMessageViewSeeker (state,data){
    state.messageViewSeeker = data.data
  },
  setMessageCompany (state,d){
    state.messageCompany = d.data
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js